import reducer from'store/v2/index';import actionType from'./constants';export default reducer(actionType);